import { FlaskConical } from "lucide-react";
import { useEffect } from "react";
import { useAppSelector } from "../../../app/store";
import { isPreviewFeatureEnabled } from "../../configs/logic/Slice";

const BANNER_HEIGHT = 64;

interface FeaturePreviewBannerProps {
  featureName: string;
}

const FeaturePreviewBanner = ({ featureName }: FeaturePreviewBannerProps) => {
  const isVisible = useAppSelector(isPreviewFeatureEnabled(featureName));

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--preview-banner-height",
      isVisible ? `${BANNER_HEIGHT}px` : "0px"
    );
    return () => {
      document.documentElement.style.setProperty(
        "--preview-banner-height",
        "0px"
      );
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div
      className="flex w-full items-center bg-[#334155] px-4 py-3 gap-4 mb-4 shrink-0"
      style={{ height: BANNER_HEIGHT }}
    >
      <FlaskConical className="h-6 w-6 shrink-0 text-[#FFFFFF] mr-2" />

      <div className="flex flex-1 flex-col justify-center">
        <span className="font-sans text-xs font-normal leading-4 text-[#FFFFFF]">
          You’re previewing an early version of this feature. While core
          workflows are available, some functionality, data accuracy, formatting,
          and user experience details are still being validated and improved based
          on feedback.
        </span>
      </div>
    </div>
  );
};

export default FeaturePreviewBanner;